import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
//API
import { BranchOfficeFetchAPI } from '../../../api/BranchOffices';
import { UsersFetchAPI } from '../../../api/Users';
import { OrdersFetchAPI } from '../../../api/Orders';

// External Componets
import moment from 'moment-timezone';
import Select from 'react-select';
//Internal components 
import ReportTable from '../table/ReportTable';
import CardTotals from '../cards/CardTotals';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
//External components 
import Button from 'react-bootstrap/Button';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { DeletedTempOrdersFetchAPI } from '../../../api/DeletedTemporalOrders';
pdfMake.vfs = pdfFonts.pdfMake.vfs


const PreAccountReport = ({ selectedUserOption, setSelectedUserOption, cashiers, setCashiers, selectedBranch, setSelectedBranch }) => {
    //Params
    let { business_code } = useParams();
    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    //States 

    const [userBranchoffices, setUserBranchs] = useState([]);
    const [userBusiness, setUserBusiness] = useState({
        id: 0
    });
    const [initialDate, setInitialDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
    const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00')
    //States of search select 

    const [machineCase, setMachineCase] = useState(false);
    const [vendingCase, setVendingCase] = useState(false);
    const [url, setUrl] = useState(null);

    const [data, setReportData] = useState({
        totalTaxSales: 0,
        subTotalSales: 0,
        totalSales: 0,
        totalDiscounts: 0,
        totalDevolutions: 0,
        business: '',
        user: '',
        machines: [],
        paymenthods: [],
        createdAt: '',
        branchofficeDate_orders: [],
        orders: []
    });

    //Functio to get cashier users depending of the branch selected
    const getCashiers = async (branchSelected) => {
        let response;
        try {
            //We get the users depending the branch selected 
            if (branchSelected === 0) {
                //If the branch selected is 0 it means that we want the users of the business (all)
                //We get the user cashiers of the business
                response = await UsersFetchAPI.getUsersByBusinessAndRole(userBusiness.id, [4, 21], token);
            } else {
                //We get the user cashiers of the branch selected
                response = await UsersFetchAPI.getUsersByBranchofficesAndRole([branchSelected], [4, 21], token);
            }
            setCashiers(response.data.users)
        } catch (err) {
            setCashiers([])
        }
    }

    //The default option of the select input 
    const defaultOption = [{ label: 'Seleccione...', value: 0 }];

    //Get users (cashiers)
    const usersList = cashiers.map((user) => ({
        label: user.user_name + ' ' + user.lastName + ': ' + user.idCard,
        value: user.user_id
    }));

    //Function to get the report of the branch office 
    const getReport = async (dateMin, dateMax) => {
        let response;
        try {
            //We show a loading alert 
            LoadingAlert();

            //We get the transactions depending of the user selected
            if (selectedUserOption === null) {
                //We get the transaction general info with the admin user logged 
                response = await DeletedTempOrdersFetchAPI.getDeletedTransactionReport(business_code, selectedBranch.code, dateMin, dateMax, 0, true, token);
            } else {
                //We get the transaction info with the user selected
                response = await DeletedTempOrdersFetchAPI.getDeletedTransactionReport(business_code, selectedBranch.code, dateMin, dateMax, selectedUserOption.value, true, token);
            }

            console.log(response)
            //We set the info 
            setReportData({
                totalTaxSales: response.data.analitics.totalTaxSales,
                subTotalSales: response.data.analitics.subTotalSales,
                totalSales: response.data.analitics.totalSales,
                totalDiscounts: response.data.analitics.totalDiscounts,
                business: response.data.analitics.business,
                branchoffice: response.data.analitics.branchoffice,
                machines: response.data.analitics.machines,
                paymenthods: response.data.analitics.paymenthods,
                createdAt: response.data.analitics.createdAt,
                branchofficeDate_orders: response.data.analitics.branchofficeDate_orders,
                totalDevolutions: response.data.analitics.totalDevolutions,
                user: response.data.analitics.user_selected,
                orders: response.data.temp_orders
            });

            //We show a success alert
            SuccessAlert();
        } catch (err) {
            //We show a error alert 
            ErrorAlert('No tiene información')
            console.log(err)
        }
    }

    //Event to detect the user selected on search select 
    const handleChangeUsers = (option) => {
        //We check if the option is null 
        if (option.value === 0) {
            setSelectedUserOption(null);
        } else {
            setSelectedUserOption(option);
        }
    };

    //Function to populate the orders details by createdAt date 
    const tableBranchOfficeOrders = () => {
        let branchOfficeOrdersData = data.branchofficeDate_orders;
        let rows = [];
        //We construc the table 
        for (let i = 0; i < branchOfficeOrdersData.length; i++) {
            let branchOfficeOrdersData_info = branchOfficeOrdersData[i];
            {/* Encabezado de la tabla de Productos  */ }
            rows.push(
                // ?Title Of Table
                {
                    text: 'Fecha de las pre cuentas: ' + branchOfficeOrdersData_info.branchOfficeDate,
                    style: 'subheaderRight',
                },
                {
                    style: 'tableExample',
                    table: {
                        widths: [140, '*', 150],
                        headerRows: 1,
                        // dontBreakRows: true,
                        // keepWithHeaderRows: 1,
                        body: [
                            //Values of Reports 
                            [
                                //Tables Headers 
                                {
                                    text: 'N°.Precuenta',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                },
                                {
                                    text: 'Método de Pago',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                },
                                {
                                    text: 'Total',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                }
                            ],
                        ]
                    }, layout: 'lightHorizontalLines'
                },
            );
            //We get the final row position to get the table of the orders 
            let final_row_position = rows.length;
            //We construct the rows of the table 
            for (let j = 0; j < branchOfficeOrdersData_info.orders.length; j++) {
                let order = branchOfficeOrdersData_info.orders[j];
                let data_row = [
                    //Column 1
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: 'Precuenta:# ' + order.code,
                    },

                    //Column 2
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: order.devolution_order_reference !== undefined ? 'Devolución de ' + order.paymenthod + ' de la orden #' + order.devolution_order_reference.code : order.paymenthod,
                    },

                    //Column 3
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: ' $ ' + order.total.toFixed(2),
                    },

                ]
                {/* Filas de la tabla completa de ordenes */ }
                rows[final_row_position - 1].table.body.push(data_row);
            }
        }
        return rows

    }




    //We create the pdf 
    const createPdf = () => {
        let machines = []
        let date = ''
        let hour = ''

        //validationof fields
        if (data.length !== 0) {
            machines = data.machines.join(', ');
            date = data.createdAt.split('T')[0];
            hour = data.createdAt.split('T')[1];
        }
        //Information
        let name_bussiness = data.business
        let name_branch = data.branchoffice


        const docDefinition = {

            pageSize: 'A4',
            pageMargins: [23, 10, 23, 5],

            content: [
                //?IMG
                {
                    "image": "logo-smartpay",
                    width: 100,
                },
                //?Title Report 
                {
                    stack: [
                        'Reporte de pre cuentas eliminadas',
                    ],
                    style: 'header'
                },

                //Information Bussiness
                //? 1 --------------------------
                {
                    text: [
                        { text: 'Empresa:', style: 'subheader' },
                        name_bussiness
                    ], margin: [0, 20, 0, 5]
                },
                //? 2 --------------------------       
                {
                    text: [
                        {
                            text: name_branch !== '' ? 'Sucursal:' : '',
                            style: 'subheader'
                        },
                        name_branch !== '' ? name_branch : '',
                    ], margin: [0, 0, 0, 5]
                },
                //? 3 --------------------------
                {
                    text: [
                        {
                            text: data.user.name !== '' ? 'Cajera/o : ' + data.user.name : '',
                            style: 'subheader'
                        },
                    ], margin: [0, 0, 0, 5]
                },

                // {
                //     text: data.user.name !== '' ? 'Cajera/o : ' + data.user.name : '',
                //     style: 'subheader'
                // },
                //? 4 --------------------------
                {
                    text: [
                        {
                            text: 'Máquinas:',
                            style: 'subheader',
                        },
                        machines
                    ], margin: [0, 0, 0, 5]
                },

                //? 5 --------------------------           
                {
                    text: [
                        {
                            text: 'Fecha:',
                            style: 'subheader',
                            margin: [0, 0, 0, 10]
                        },
                        date
                    ], margin: [0, 0, 0, 5]
                },

                //? 6 --------------------------
                {
                    text: [
                        {
                            text: 'Hora: ',
                            style: 'subheader',
                            margin: [0, 0, 0, 20]
                        },
                        hour
                    ]
                },


                //?Title Of Table
                {
                    text: 'Ordenes',
                    style: 'titles', margin: [0, 15, 0, 0]
                },
                //Title Of Table
                tableBranchOfficeOrders()
            ],

            images: {
                "logo-smartpay": "https://res.cloudinary.com/dk3x6ubyi/image/upload/v1682698324/hi2vihfdtgg98ybwbxnn.png"
            },

            styles: {
                header: {
                    fontSize: 16,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 5, 0, 10],
                },
                titles: {
                    fontSize: 14,
                    bold: true,
                    alignment: 'center',
                },
                subheader: {
                    fontSize: 12,
                    bold: true,
                    alignment: 'left',
                },
                subheaderRight: {
                    fontSize: 12,
                    alignment: 'right',
                    color: '#A8A8A8'
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    fillColor: '#43CD3B',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                },

                tableHeader2: {
                    fillColor: '#26BABF',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                },

                tableHeader3: {
                    fillColor: '#266DBF',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                }


            }

        }


        const pdfGenerator = pdfMake.createPdf(docDefinition);
        pdfGenerator.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            setUrl(url)

        })

        pdfGenerator.download();
    }


    //Hook to load the initial data 
    useEffect(() => {
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);
        //We set the business user 
        setUserBusiness(user.business);


    }, []);

    //Hook to load the users depending the selection of branch 
    useEffect(() => {
        if (userBusiness?.id) {
            getCashiers(selectedBranch.id);
        }
    }, [selectedBranch, userBusiness]);


    return (
        <div>
            <h4>Filtros</h4>
            <div className="row gx-3 gy-2 align-items-center bg-white p-2 my-3 border-sp border shadow-sm">
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                        <label htmlFor="input_from">Desde</label>
                        <input type="date" name="initialDate" onChange={e => setInitialDate(e.target.value + "T00:00:00.000+00:00")} className="control mt-3" />
                    </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                        <label htmlFor="input_from">Hasta</label>
                        <input type="date" name="finishDate" onChange={e => setMaxDate(e.target.value + "T23:59:59.000+00:00")} className="control mt-3" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <label htmlFor="input_from">Cajeros (opcional)</label>
                    <Select
                        className='w-100'
                        value={selectedUserOption}
                        options={[defaultOption[0], ...usersList]}
                        onChange={handleChangeUsers}
                    />

                </div>
                <div className=" d-flex justify-content-center justify-content-sm-end mb-3">
                    <button type="button" onClick={e => getReport(initialDate, maxDate)} className="btn btn-success px-5">Aceptar</button>
                </div>
            </div>

            <div className="d-flex justify-content-between mt-3">
                <h5 className="mt-4">Reporte de pre cuentas eliminadas </h5>
                <div className="mt-3 mb-2">
                    <Button variant="outline-secondary" className='mx-3' onClick={createPdf}>
                        <i className="uil uil-file-download "></i> <span >Descargar PDF</span>
                    </Button>
                </div>
            </div>

            {/**Table */}
            <ReportTable
                table_name="Tabla de pre cuentas eliminadas"
                table_headers={["Fecha", "Hora", "Orden", "Total", "Subtotal", "Itbms", "Descuento"]}
                table_type="preaccount_report"
                table_data={data.orders}
            />
        </div>



    );
}

export default PreAccountReport;